import {AfterViewInit, Component, OnInit} from "@angular/core";
import {JwtHelperService} from "@auth0/angular-jwt";
import {ProfileMessage} from "../../_services/profile.message";
import {ActivatedRoute, Router} from "@angular/router";
import {UserService} from "../dashboard/services/user.service";
import {ParameterService} from "../../_services/parameter.service";

@Component({
    selector: 'my-wallet-ceu-detail',
    templateUrl: './wallet-ceu-detail.component.html',
    styleUrls: ['./my-wallet.component.scss'],
})
export class WalletCeuDetailComponent implements OnInit, AfterViewInit {
    attendanceTypes: any;
    documentTypes: any = {};
    integerLogics: any = {};
    isLoggedIn?: boolean;
    user: any;
    activity: any = {};
    ceu: any = {}

    constructor(
        private userService: UserService,
        private jwtHelper: JwtHelperService,
        private activatedRoute: ActivatedRoute,
        private profileMsg: ProfileMessage,
        private router: Router,
        private parameterService: ParameterService,
    ) {
    }

    async ngOnInit(): Promise<void> {
        this.isLoggedIn = !this.jwtHelper.isTokenExpired();
        this.documentTypes = await this.parameterService.getParameterByName("DOCUMENT_TYPE");
        this.integerLogics = await this.parameterService.getParameterByName("INTEGER_LOGICAL_OPERATOR");
        if (this.isLoggedIn) {
            this.profileMsg.currentMessage.subscribe(r => {
                if(r) {
                    this.user = r;
                }
            })
        }

        this.ceu = await this.userService.getUserCEUById(this.activatedRoute.snapshot.params.id);
        if(this.ceu.document.activityResponse) {
            this.activity = JSON.parse(this.ceu.document.activityResponse);
            console.log(this.activity);
        }


    }

    maskingColumn(label: string, value: any, items: any[], val: any): any {
        // tslint:disable-next-line:triple-equals
        const f = items.find(i => i[value] == val);
        return (f) ? f[label] : '-';
    }

    goBack() {
        this.router.navigate(['/my-wallet'], {queryParams: {tab: 'ceus'}}).then();
    }

    ngAfterViewInit() {

    }
}
